import { render, staticRenderFns } from "./LeadsTabs.vue?vue&type=template&id=e576c47a&"
import script from "./LeadsTabs.vue?vue&type=script&lang=js&"
export * from "./LeadsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports